module.exports = __webpack_public_path__ + "static/media/read.ce82df70.png";